import { ComponentPropsWithRef } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { api } from '../../server/api';
import { Notify } from '../Notify';
import styles from './style.module.css';

interface IClipboard extends ComponentPropsWithRef<'button'> {
  shareUrl: string;
  actionId?: string;
}

export function Clipboard({ shareUrl, actionId }: IClipboard) {
  const { client, player } = useAuth();

  const registerPlayerOnAction = async (actionId: string) => {
    try {
      const parameters = {
        searchFunctionality: 'registerPlayerInAction',
        userType: 'player',
        actionId,
        clientId: client.id,
      };

      await api.post(`/actions`, parameters);
    } catch (error) {
      console.log('error registerPlayerOnAction-->', error);
    }
  };

  const increaseShareChannelCount = async (
    channel: string,
    actionId: string
  ) => {
    try {
      const parameters = {
        updateFunctionality: 'increaseShareChannelCount',
        userType: 'player',
        actionId,
        playerId: player.id,
        channel,
        clientId: player.clientId,
      };

      await api.post('/update', parameters);
    } catch (error) {
      console.log('error increaseShareChannelCount-->', error);
    }
  };

  const onCopy = async (shareUrl: string, actionId: string) => {
    navigator.clipboard.writeText(shareUrl);
    Notify('Texto copiado com sucesso', 'success');

    await registerPlayerOnAction(actionId);
    await increaseShareChannelCount('copiedlink', actionId);
  };

  return (
    <>
      <div className={styles.clipboard}>
        <input
          className="px-4"
          placeholder="Link encurtado"
          value={shareUrl}
          disabled
          type="text"
        />
        <button
          onClick={() => onCopy(shareUrl, actionId ? actionId : '')}
          className="p-4"
        >
          <i className="material-icons-outlined">content_copy</i>
        </button>
      </div>
    </>
  );
}
